/* ========== 対象処理 ========== */
// 1. 会員登録用メール送信
//
// 会員登録
// 2. 仮会員情報表示（メールアドレス）
// 3. 入力内容確認欄表示
// 4. 本会員登録

document.addEventListener("DOMContentLoaded", function () {
  const sendEmailButton = document.getElementById('send_email_button');
  const vipArea = document.getElementById('vip_area');
  const confirmAccountButton = document.getElementById('confirm_account_button');
  const registerAccountButton = document.getElementById('register_account_button');
  const now = new Date();
  const year = now.getFullYear();

  // 会員登録用メール送信
  const mail_vip_form = document.getElementById("mail_vip_form");
  if (sendEmailButton) {
    mail_vip_form.addEventListener("submit", (e) => {
      e.preventDefault();
      sendRegisterEmail(sendEmailButton);
    });
  }

  /* ========== 会員登録 ========== */
  // 会員登録ページ
  if (vipArea) {
    // 仮会員情報表示
    setPreCustomer(vipArea);
    let furigana = document.querySelector('.furigana');
    changeLang(furigana);

    // 確認ボタン
    const vip_input_form = document.getElementById("vip_input_form");
    if(confirmAccountButton){
      //郵便番号バリデーション
      setAddress();

      vip_input_form.addEventListener("submit", (e) => {
        e.preventDefault();
        confirmCustomer();
      });
    }

    // 登録ボタン
    registerAccountButton.addEventListener("click", () => {
      registerCustomer(registerAccountButton);
    });
  }

});

// 会員登録用メール送信
const sendRegisterEmail = async (sendEmailButton) => {
  const url = `${APP_PROXY_URL}/api/register_email`;
  let successMessage = document.getElementById('success_send_message');
  let errorMessage = document.getElementById('error_send_message');
  successMessage.innerText = '';
  errorMessage.innerText = '';
  errorMessage.style.display = "none";
  btnLoading(sendEmailButton);

  const params = validateRegisterEmail(SEND_MAIL_TYPE.VIP);
  if (!params) {
    btnStopLoading(sendEmailButton);
    return;
  }

  const res = await fetchPostMethod(url, params);

  if (res.message == 'ok') {
    const token = random();
    window.location.href = `https://${location.hostname}/pages/email_register_mail?token=${token}`;
  } else {
    if(res.message == undefined){
      errorMessage.innerText = 'サーバーエラーが発生しました';
    }else{
      errorMessage.innerText = res.message;
    }
    errorMessage.style.display = "block";
    btnStopLoading(sendEmailButton);
  }
};

// 登録メールアドレスページ表示
const setPreCustomer = async (parent) => {
  const link = new URL(window.location.href);
  const token = link.searchParams.get('token');

  if (!token) {
    checkHasToken(parent);
    return;
  }

  const url = new URL(`${APP_PROXY_URL}/api/pre_customer`);
  url.searchParams.set('token', token);
  url.searchParams.set('status', ACTIVATE_STATUS.PROVISIONAL_NEW);

  const customer = await getPreCustomer(url.href);

  if (!customer) {
    checkHasToken(parent);
    return;
  }

  // 仮会員登録情報表示（メールアドレスのみ）
  setRegisterPreCustomerFields(customer);
};

// 仮会員登録情報設定
const setRegisterPreCustomerFields = (customer) => {
  let email = document.querySelector('.--mail ._customerData');
  email.innerText = customer.email;
};

// 登録内容確認
const confirmCustomer = async () => {
  let errorMessage = document.getElementById('error_message');
  errorMessage.innerText = '';

  const link = new URL(window.location.href);
  const token = link.searchParams.get('token');
  if(!token) {
    errorMessage.innerText = 'セッションがタイムアウトした、もしくは不正な画面遷移が行われた可能性があります。お手数ですが、最初から操作をやり直してください。';
    return;
  }

  const params = validateRegisterCustomer(token, VIP_STATUS.VIP);

  if (!params) {
    errorMessage.innerText = '入力内容に不備があります';
    errorMessage.style.display = "block";
    return;
  }else{
    errorMessage.style.display = "none";
  }

  setNextField();
  setConfirmCustomer(params);
};

// 会員登録
const registerCustomer = async (registerAccountButton) => {
  const url = `${APP_PROXY_URL}/api/customer`;
  let errorMessage = document.getElementById('error_message');
  errorMessage.innerText = '';
  btnLoading(registerAccountButton);

  const link = new URL(window.location.href);
  const token = link.searchParams.get('token');
  if(!token) {
    btnStopLoading(registerAccountButton);
    errorMessage.innerText = 'セッションがタイムアウトした、もしくは不正な画面遷移が行われた可能性があります。お手数ですが、最初から操作をやり直してください。';
    return;
  }

  const params = validateRegisterCustomer(token, VIP_STATUS.VIP);
  if (!params) {
    setBackField();
    btnStopLoading(registerAccountButton);
    return;
  }

  const res = await fetchPostMethod(url, params);
  if (res.message == 'ok') {
    window.location = getMultipassUrl(res.multipassToken);
  } else {
    if (res.error) {
      res.message = 'サーバーエラーが発生しました';
    }
    if (res.errors){
      const ignoreError = ['token', 'type'];
      setServerValidationError(res.errors, ignoreError);
    }

    setBackField(res.message);
    btnStopLoading(registerAccountButton);
  }
};

// 登録内容確認ページ表示
const setConfirmCustomer = (customer) => {
  let mainInfo = document.querySelectorAll('.main_info ._customerData');
  let lang = WOVN.io.getCurrentLang().code;

  mainInfo[0].innerText = document.querySelector('.--mail ._customerData').innerText;
  mainInfo[2].innerText = `${customer.lastName} ${customer.firstName}`;
  let furigana = document.querySelector('.main_info .furigana');
  if(lang == 'ja'){
    mainInfo[3].innerText = `${customer.lastKana} ${customer.firstKana}`;
    furigana.style.display = 'flex';
  }else{
    furigana.style.display = 'none';
  }
  mainInfo[4].innerText = setCountry(customer);
  let postcode = document.querySelector('.main_info .f-postcode');
  let prefectures = document.querySelector('.main_info .f-prefectures');
  if (customer.country == 'JP') {
    mainInfo[5].innerText = customer.postalCode;
    mainInfo[6].innerText = customer.prefecture;
    postcode.style.display = 'flex';
    prefectures.style.display = 'flex';
  } else {
    postcode.style.display = 'none';
    prefectures.style.display = 'none';
  }
  mainInfo[7].innerText = customer.countyCityAddress;
  mainInfo[8].innerText = customer.townAddress;
  mainInfo[9].innerText = customer.buildingName;
  mainInfo[10].innerText = setSex(customer);
  mainInfo[11].innerText = setBirthday(customer);
  setNewsletter(customer, mainInfo[12]);
  mainInfo[13].innerText = setShopDM(customer);
  setBlandList(customer, mainInfo[14]);
};

const setAddress = () => {
  var isJapanPostalCodeLoaded = false;

    if(!isJapanPostalCodeLoaded){
      // ZipCode AutoFill
      if (typeof JapanPostalCode !== 'undefined') {
        const options = {
          name: 'register',
          messages: {
            addressExists: "住所が正しくありません",
            addressTownExists: "郵便番号に基づいた住所をご登録ください。ご入力いただいた住所の表記を再度ご確認ください。例）〇 三番町 × 3番町",
          }
        };

        // Add New Address
        new JapanPostalCode(
          {
            container: '#vip_input_container',
            form: '#vip_input_form',
            buttonSubmit: '#confirm_account_button',
            country: '[name="country"]',
            zipCode: '[name="postalCode"]',
            city: '[name="countyCityAddress"]',
            province: '[name="province"]',
            address01: '[name="townAddress"]',
            address02: '[name="buildingName"]',
            firstName: '[name="firstName"]',
            lastName: '[name="lastName"]',
            firstNameKana: '[name="firstKana"]',
            lastNameKana: '[name="lastKana"]',
            phone: '',
          },
          options
        );
      }

      isJapanPostalCodeLoaded = true;
    }
}